import React from 'react';
import * as Styles from './NewBMStep1.style';
import { Icon } from 'semantic-ui-react';
import { navLinks } from 'utils/nav-links-util';
import { Notification } from 'components/vm-deployment/components';
import { useTranslation, Trans } from 'react-i18next';
import ServerSideStaticCard from 'components/bm-deployment/server-size-card/ServerSideStaticCard';
import { totalPrice } from 'components/vm-deployment/util';
import { get } from 'lodash';
import classes from 'assets/css/fading-animation.module.css';
import { useSelector } from 'react-redux';
import Heading from 'components/Heading/Heading';
import FormikErrorMessage from 'components/formik-error-message';
import ServerContainer from 'components/bm-deployment/ServerContainer';

const NewBMStep1 = ({ serverSizesData, onServerSizeSelection, formikProp, isShowPriceButton }) => {
  const { t } = useTranslation();
  const userAccount = useSelector((state) => state.user.account);
  const isSaleAvailable = serverSizesData?.bm_sizes?.some((data) => Number(data.price) - Number(data.sale_price));
  const { values } = formikProp;

  const checkIsServerAvailable = (serverName) => {
    let value = serverSizesData?.bm_sizes?.some(
      (serverSize) =>
        serverSize.active && serverSize.cpugen == serverName && serverSize?.availableregions?.includes(values.region),
    );
    return value;
  };

  return (
    <Styles.NewBMStep1SC id="ST1">
      <Heading name={'bm/instance/create.step1_string2'}>
        <Styles.Margin />
        <Styles.ServerSizeGrid>
          <ServerSideStaticCard />
        </Styles.ServerSizeGrid>
        <>
          {checkIsServerAvailable('xeone5v4') && (
            <ServerContainer
              serverType={'xeone5v4'}
              serverSizes={serverSizesData}
              heading={'bm/instance/create.step1_string39'}
              formikProp={formikProp}
              onClick={onServerSizeSelection}
              userAccount={userAccount}
            />
          )}
          {checkIsServerAvailable('xeongold') && (
            <ServerContainer
              serverType={'xeongold'}
              serverSizes={serverSizesData}
              heading={'bm/instance/create.step1_string40'}
              formikProp={formikProp}
              onClick={onServerSizeSelection}
              userAccount={userAccount}
            />
          )}
          {checkIsServerAvailable('xeone5v4raid') && (
            <ServerContainer
              serverType={'xeone5v4raid'}
              serverSizes={serverSizesData}
              heading={'bm/instance/create.step1_string41'}
              formikProp={formikProp}
              onClick={onServerSizeSelection}
              userAccount={userAccount}
            />
          )}
          {checkIsServerAvailable('xeone3v2') && (
            <ServerContainer
              serverType={'xeone3v2'}
              serverSizes={serverSizesData}
              heading={'bm/instance/create.step1_string42'}
              formikProp={formikProp}
            />
          )}
          {checkIsServerAvailable('xeone5v2') && (
            <ServerContainer
              serverType={'xeone5v2'}
              serverSizes={serverSizesData}
              heading={'bm/instance/create.step1_string42'}
              formikProp={formikProp}
            />
          )}
        </>
        {isSaleAvailable && (
          <>
            <Styles.NotificationContainer>
              <Notification>
                <Icon name="info circle" />
                {t('bm/instance/create.step1_string7')}
              </Notification>
            </Styles.NotificationContainer>
            <Styles.SaleNotification>
              <Notification>
                <Icon name="info circle" />
                {t('bm/instance/create.step1_string8')}
              </Notification>
            </Styles.SaleNotification>
          </>
        )}
        <div className={isShowPriceButton ? classes.price_box_show : classes.price_box_hide}>
          <Styles.Footer>
            <Styles.FooterText>
              <Trans
                i18nKey={'string1'}
                values={{
                  currency_symbol: userAccount.account_currency_symbol,
                  price: totalPrice(get(formikProp, 'values.prices', 0), true),
                }}
              />
            </Styles.FooterText>
            <Styles.ButtonSC color="green" size="mini" href={navLinks.billing.link}>
              <Icon name="credit card" />
              {t('string2')}
            </Styles.ButtonSC>
          </Styles.Footer>
        </div>
      </Heading>
      <FormikErrorMessage value="size" formikProp={formikProp} />
    </Styles.NewBMStep1SC>
  );
};

export default NewBMStep1;
